export default __webpack_public_path__ + "static/joris_rujis-433beefec4a73c7a8b0866602031d508.png";